import * as React from 'react';

export const Check = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" {...props}>
    <polygon
      fill="currentColor"
      points="10.6641308 1.09 11.8184166 2.04792706 4.46390147 10.9099928 0.185 6.17837674 1.29754748 5.1722763 4.41523201 8.61981682"
    />
  </svg>
);
